
import { defineComponent } from 'vue'
import { Plan } from '../../types/plan.types'
import ActivationToggle from '../common/ActivationToggle.vue'

export default defineComponent({
    name: 'PlanList',
    components: {
        ActivationToggle,
    },
    props: {
        plans: {
            type: Array as () => Plan[],
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        currentPage: {
            type: Number,
            default: 1,
        },
        totalPages: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            activeDropdown: null as string | null,
            searchQuery: '',
            statusFilter: 'all',
            _onDocumentClick: null as null | ((event: MouseEvent) => void),
        }
    },
    computed: {
        filteredPlans() {
            let filtered = [...(this as any).plans]

            // Фильтр по статусу
            if ((this as any).statusFilter !== 'all') {
                filtered = filtered.filter(plan => plan.status === (this as any).statusFilter)
            }

            // Поиск по названию
            if ((this as any).searchQuery.trim()) {
                const query = (this as any).searchQuery.toLowerCase().trim()
                filtered = filtered.filter(plan => plan.name.toLowerCase().includes(query))
            }

            return filtered
        },
    },
    methods: {
        getStatusText(status: string): string {
            const statusMap: Record<string, string> = {
                draft: 'Черновик',
                published: 'Опубликован',
                archived: 'Архив',
            }
            return statusMap[status] || status
        },

        formatDate(date: string | Date): string {
            const d = new Date(date)
            return d.toLocaleDateString('ru-RU', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            })
        },

        toggleDropdown(planId: string, event: Event) {
            event.stopPropagation()
            this.activeDropdown = this.activeDropdown === planId ? null : planId
        },

        editPlan(plan: Plan) {
            this.activeDropdown = null
            this.$emit('edit-plan', plan)
        },

        copyPlan(plan: Plan) {
            this.activeDropdown = null
            this.$emit('copy-plan', plan)
        },

        deletePlan(plan: Plan) {
            this.activeDropdown = null
            this.$emit('delete-plan', plan)
        },

        togglePlanActivation(plan: Plan, isActive: boolean) {
            // Обновляем локальное состояние плана
            this.$set(plan, 'isActive', isActive)
            // Эмитим событие для родительского компонента
            this.$emit('toggle-activation', plan)
        },

        setStatusFilter(status: string) {
            this.statusFilter = status
        },
    },
    mounted() {
        // Закрытие dropdown при клике вне его
        this._onDocumentClick = (event: MouseEvent) => {
            const target = event.target as HTMLElement
            if (!target.closest('.actions-dropdown')) {
                this.activeDropdown = null
            }
        }
        document.addEventListener('click', this._onDocumentClick)
    },
    beforeDestroy() {
        if (this._onDocumentClick) {
            document.removeEventListener('click', this._onDocumentClick)
            this._onDocumentClick = null
        }
    },
})
